import { render, staticRenderFns } from "./folderPermissionDialog.vue?vue&type=template&id=6fbacb0e&scoped=true"
import script from "./folderPermissionDialog.vue?vue&type=script&lang=js"
export * from "./folderPermissionDialog.vue?vue&type=script&lang=js"
import style0 from "./folderPermissionDialog.vue?vue&type=style&index=0&id=6fbacb0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbacb0e",
  null
  
)

export default component.exports